
import React, { useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import "./section_card.scss";

function SkuCard({ section, description, onEdit, onDelete }) {
  const [open, setOpen] = useState(false);
  const [deleteOption, setDeleteOption] = useState("unlink");

  const handleDeleteClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleProceed = () => {
      console.log("dddd",deleteOption)
      onDelete(deleteOption); // Call the delete function
    
    setOpen(false);
  };

  return (
    <>
      <Card className="category-card" variant="outlined">
        <CardContent>
          <div>SKU Code</div>
          <Typography variant="h5" component="h2">
            {section}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {description}
          </Typography>
          <div className="button-container">
            <IconButton onClick={onEdit} aria-label="edit" className="edit-button">
              <EditIcon />
            </IconButton>
            <IconButton onClick={handleDeleteClick} aria-label="delete" className="delete-button">
              <DeleteIcon />
            </IconButton>
          </div>
        </CardContent>
      </Card>

      {/* Delete Confirmation Popup */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>⚠️ Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            If you delete this SKU, all linked items will also be deleted.  
            Do you want to **delete all items** or **only unlink them** from this SKU?
          </Typography>

          <RadioGroup value={deleteOption} onChange={(e) => setDeleteOption(e.target.value)}>
            <FormControlLabel value="unlink" control={<Radio />} label="Unlink items from this SKU" />
            <FormControlLabel value="delete" control={<Radio />} label="Delete SKU and linked items" />
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">Cancel</Button>
          <Button onClick={handleProceed} color="primary" variant="contained">Proceed</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SkuCard;
